import React from 'react'

const ShareIcon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24px' height='24px'>
			<path
				d='M18 2a3 3 0 00-3 3 3 3 0 00.055.56L7.939 9.71A3 3 0 006 9a3 3 0 00-3 3 3 3 0 003 3 3 3 0 001.936-.713l7.119 4.152A3 3 0 0015 19a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-1.938.713L8.945 12.56A3 3 0 009 12a3 3 0 00-.055-.56l7.116-4.15A3 3 0 0018 8a3 3 0 003-3 3 3 0 00-3-3z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ShareIcon
